import { useState } from "react";
import { Link } from "react-router-dom";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import App_logo from "assets/images/BMAx_orderSystem.png";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import { notifyCenter } from "utils/toast";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:3001";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim()) {
      notifyCenter("error", "Skriv inn e-postadressen din.", { duration: 3000 });
      return;
    }
    setIsLoading(true);
    try {
      // Plain fetch, not axiosInstance — this page runs logged-out and must
      // not attach a stale Bearer token (same pattern as VendorLink).
      const res = await fetch(`${API_BASE}/connect`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ action: "forgot_password", email: email.trim() }),
      });
      const data = await res.json();
      if (!data?.status) {
        throw new Error(data?.message || "Noe gikk galt. Prøv på nytt.");
      }
      setSent(true);
    } catch (err) {
      notifyCenter("error", err.message || "Noe gikk galt. Prøv på nytt.", { duration: 4000 });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CoverLayout
      header={
        <SoftBox
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            mb: 3,
          }}
        >
          <SoftBox component={Link} to="/" sx={{ maxWidth: 300, width: "100%" }}>
            <img src={App_logo} alt="App Logo" style={{ width: "100%", height: "auto", display: "block" }} />
          </SoftBox>
        </SoftBox>
      }
    >
      {isLoading && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <CircularProgress size={60} color="info" />
        </Box>
      )}
      {sent ? (
        <SoftBox textAlign="center">
          <SoftTypography variant="h5" fontWeight="bold" mb={2}>
            Sjekk e-posten din
          </SoftTypography>
          <SoftTypography variant="button" color="text" fontWeight="regular">
            Hvis e-postadressen er registrert hos oss, har vi sendt deg en lenke for å
            tilbakestille passordet. Lenken er gyldig i 1 time.
          </SoftTypography>
          <SoftBox mt={3}>
            <SoftButton component={Link} to="/authentication/log-in" variant="gradient" color="info" fullWidth>
              Tilbake til innlogging
            </SoftButton>
          </SoftBox>
        </SoftBox>
      ) : (
        <SoftBox component="form" role="form" onSubmit={handleSubmit}>
          <SoftBox mb={2} textAlign="center">
            <SoftTypography variant="h5" fontWeight="bold">
              Glemt passord?
            </SoftTypography>
            <SoftTypography variant="button" color="text" fontWeight="regular">
              Skriv inn e-postadressen din, så sender vi deg en lenke for å tilbakestille passordet.
            </SoftTypography>
          </SoftBox>
          <SoftBox mb={3}>
            <SoftInput
              type="email"
              placeholder="Skriv inn e-posten din"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </SoftBox>
          <SoftBox mt={3} mb={1}>
            <SoftButton variant="gradient" color="info" fullWidth type="submit">
              Send lenke
            </SoftButton>
          </SoftBox>
          <SoftBox mt={2} textAlign="center">
            <SoftTypography
              component={Link}
              to="/authentication/log-in"
              variant="button"
              color="info"
              fontWeight="medium"
              textGradient
            >
              Tilbake til innlogging
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      )}
    </CoverLayout>
  );
}

export default ForgotPassword;
